import axios from "../../axios";

export default {
    getAllActivations(data) {
        return axios.get('activations/dashboard', {params: data})
    },
    getSingleActivation(data) {
        return axios.get('activations/single-activation', {params: data})
    },
    deleteActivation(data) {
        return axios.post('activations/delete-activation', data)
    },
    getAllAudiences(data) {
        return axios.get('activations/my-audiences', {params: data})
    },
    deleteAudience(data) {
        return axios.post('activations/delete-audience', data)
    },
    getSingleAudience(data) {
        return axios.get('activations/single-audience', {params: data})
    },
    getSingleCloneAudience(data) {
        return axios.get('activations/single-clone-audience', {params: data})
    },
    getAnalysisTypes() {
        return axios.get('activations/analysis-types')
    },
    getSignalProviders(data) {
        return axios.get('activations/signal-providers', {params: data})
    },
    getPoiData(data) {
        return axios.get('activations/poi-data', {params: data})
    },
    getSegments() {
        return axios.get('activations/segments')
    },
    getAnonymizedComponentData() {
        return axios.get('activations/anonymized-fields')
    },
    getCategories() {
        return axios.get('activations/categories')
    },
    getCountries() {
        return axios.get('activations/countries')
    },
    getDmas() {
        return axios.get('activations/dmas')
    },
    getPois() {
        return axios.get('activations/pois')
    },
    getCohorts() {
        return axios.get('activations/cohorts')
    },
    getPixels() {
        return axios.get('activations/cohorts/all-campaigns')
    },
    getPixelKeys() {
        return axios.get('activations/cohorts/get-pixel-keys')
    },
    getAnalysisDataByCategory(data) {
        return axios.get('activations/analysis-data-by-category', {params: data})
    },
    getCategoriesBySegments(data) {
        return axios.get('activations/categories-by-segments', {params: data})
    },
    getLocationsByBrands(data) {
        return axios.get('activations/locations-by-brands', {params: data})
    },
    getCountriesBySelectedData(data) {
        return axios.get('activations/countries-by-selected-data', {params: data})
    },
    getCountriesBySelectedLocations(data) {
        return axios.get('activations/countries-by-locations', {params: data})
    },
    getDataBySelectedCountries(data) {
        return axios.get('/activations/data-by-selected-countries', {params: data})
    },
    getStatesByCountries(data) {
        return axios.get('activations/states-by-countries', {params: data})
    },
    getCitiesByStates(data) {
        return axios.get('activations/cities-by-states', {params: data})
    },
    createNewActivation(data) {
        return axios.post('activations/create-new-activation', data)
    },
    activateActivation(data) {
        return axios.post('activations/activate-activation', data)
    },
    getEndpointPartners(data) {
        return axios.get('activations/endpoint-partners', {params: data})
    },
    getPricingModelsByActivationPartner(data) {
        return axios.get('activations/pricing-models', {params: data})
    },
    getDataStreams(data) {
        return axios.get('activations/datastreams', {params: data})
    },
    getUserPermissions(data) {
        return axios.get('/user-permissions', data)
    },
    getAllCohorts(data) {
        return axios.get('/activations/cohorts/all-cohorts', {params: data})
    },
    createNewCohort(data) {
        return axios.post('/activations/cohorts/create-cohort', data)
    },
    uploadCohortFile(data, headers) {
        return axios.post('/activations/cohorts/file-upload', data, headers)
    },
    removeCohortFile(data) {
        return axios.post('/activations/cohorts/file-remove', data)
    },
    createCohortFromFile(data) {
        return axios.post('/activations/cohorts/create-cohort-from-file', data)
    },
    processCohortAction(data) {
        return axios.post('/activations/cohorts/process-cohort-action', data)
    },
    updateCohortName(data) {
        return axios.post('/activations/cohorts/update-cohort-name', data)
    },
    deleteCohort(data) {
        return axios.post('/activations/cohorts/delete-cohort', data)
    },
    getReportActivations(data) {
        return axios.get(`/activations/reports?sortBy=${data.sortBy}&orderBy=${data.orderBy}&q=${data.q}&startDate=${data.startDate}&endDate=${data.endDate}`)
    },
    getAppsCategories() {
        return axios.get('activations/apps/categories')
    },
    getAppsTags() {
        return axios.get('activations/apps/tags')
    },
    getAppsTagsByCategories(data) {
        return axios.get('activations/apps/tags-by-categories', {params: data})
    },
    getAppsOs() {
        return axios.get('activations/apps/os')
    },
    getAppsNames(data) {
        return axios.get('activations/apps/names', {params: data})
    },
    getAppsBundleIds(data) {
        return axios.get('activations/apps/bundleids', {params: data})
    },
}